import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'

import styles from './DataTable.module.css'

const DataTableParagraph = ({ chart }) => {
  const data = formatTableData(chart.tableValue)

  if (data.length === 0) {
    return ''
  }

  return (
    <>
      <table className={styles.datatable}>
        <caption>{chart.caption}</caption>
        <thead>
          <tr key='0'>
            {data[0].map(column => (
              <th>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.slice(1).map((row, index) => (
            <tr key={index + 1}>
              {row.map(column => (
                <td>{column}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

const formatTableData = tableData => {
  if (!tableData) {
    return []
  }

  let data = []
  const rows = tableData.split('|')

  // last row is data Caption
  rows.forEach((row, index) => {
    if (row.length > 0 && index < rows.length - 1) {
      data.push(row.split(','))
    }
  })

  return data
}

DataTableParagraph.propTypes = {
  chart: PropTypes.shape({
    tableValue: PropTypes.string.isRequired,
  }),
}

const fragments = {
  paragraph: gql`
    fragment DataTableParagraphFragment on ParagraphDataTable {
      id
      chart: fieldChart {
        tableValue
        caption
      }
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { DataTableParagraph, fragments }
